<div class="divPDF" style="margin: auto !important">
  <div *ngIf="cargaImage && url; else elseBlock" class="divPDF">
    <iframe [attr.src]="url" width="1000" height="900"> </iframe>
  </div>

  <ng-template
    #elseBlock
    style="display: flex; height: 100%; align-items: center"
  >
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </ng-template>

  <div
    *ngIf="message"
    class="divPDF"
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    "
  >
    <h3>{{ message }}</h3>
  </div>
  <button
    class="buttonPrimary"
    style="margin-top: 1rem"
    (click)="this.pdfDialogRef.close()"
  >
    Cerrar
  </button>
</div>
